'use strict';

const SITE_URL = 'https://www.ganghaolai.cn';
const SITE_NAME = '山东尚亚信息科技有限公司';
const SITE_SHORT_NAME = '尚亚科技';
const SITE_BRAND = '刚好来';
const DEFAULT_IMAGE = `${SITE_URL}/favicon.ico`;
const PUBLIC_PATHS = ['/', '/investment', '/product', '/traffic-boost', '/ganghaolai-mall', '/case', '/goin', '/download'];

const ROUTES = {
  '/': {
    title: '山东尚亚信息科技有限公司｜尚亚科技·刚好来',
    description: '山东尚亚信息科技有限公司（尚亚科技）专注企业数字化服务，打造刚好来小程序与刚好来商城，为淄博本地商业和合作伙伴提供数字化平台支持。',
    keywords: ['山东尚亚信息科技有限公司', '尚亚科技', '刚好来', '刚好来小程序', '刚好来商城', '淄博商城刚好来'],
    heading: '山东尚亚信息科技有限公司',
    summary: '尚亚科技以专业技术与可靠服务推进企业数字化建设，持续建设刚好来小程序、刚好来商城等数字化产品。',
    breadcrumbName: '首页'
  },
  '/investment': {
    title: '刚好来商城招商合作｜山东尚亚信息科技有限公司',
    description: '了解刚好来商城招商合作内容、合作模式与业务支持，携手山东尚亚信息科技有限公司共同拓展淄博本地数字商业服务。',
    keywords: ['刚好来商城', '刚好来招商合作', '淄博商城刚好来', '尚亚科技'],
    heading: '刚好来商城招商合作',
    summary: '查看刚好来商城合作方向与招商内容，了解尚亚科技面向合作伙伴提供的数字化平台与服务支持。',
    breadcrumbName: '招商合作'
  },
  '/product': {
    title: '刚好来小程序与刚好来商城｜尚亚科技产品中心',
    description: '尚亚科技产品中心介绍刚好来小程序、刚好来商城及相关数字化平台能力，帮助业务流程更加透明、协同高效、信息可追溯。',
    keywords: ['刚好来小程序', '刚好来商城', '刚好来', '尚亚科技'],
    heading: '刚好来小程序与刚好来商城',
    summary: '了解刚好来小程序、刚好来商城及尚亚科技数字化产品的建设目标、管理模式与功能模块。',
    breadcrumbName: '产品中心'
  },
  '/traffic-boost': {
    title: '流量速推｜门店抖音扫码推广解决方案｜尚亚科技',
    description: '流量速推面向餐饮、零售和本地生活门店，提供商家矩阵、永久二维码、视频素材、扫码发布与传播数据分析能力。',
    keywords: ['流量速推', '门店引流', '抖音扫码推广', '商家二维码', '本地生活营销'],
    heading: '流量速推',
    summary: '通过永久二维码、门店内容素材和扫码发布链路，连接到店顾客与门店内容传播。',
    breadcrumbName: '流量速推'
  },
  '/ganghaolai-mall': {
    title: '刚好来商城｜自营超市与本地商家入驻平台｜尚亚科技',
    description: '刚好来商城以自营超市为基础，连接本地优质商家，提供线上选购、到店自提、配送、商家入驻与本地生活消费服务。',
    keywords: ['刚好来商城', '自营超市', '商家入驻', '本地生活商城', '淄博商城'],
    heading: '刚好来商城',
    summary: '以自营超市为品质底座，连接本地优质商家，提供线上购物、自提配送和商家经营服务。',
    breadcrumbName: '刚好来商城'
  },
  '/case': {
    title: '尚亚科技经典案例｜刚好来商城与企业数字化案例',
    description: '查看山东尚亚信息科技有限公司经典案例，了解刚好来商城及企业数字化项目的实践成果与可复制经验。',
    keywords: ['尚亚科技案例', '刚好来商城案例', '淄博商城刚好来', '企业数字化案例'],
    heading: '尚亚科技经典案例',
    summary: '通过真实项目案例了解尚亚科技在刚好来商城和企业数字化建设中的实践经验。',
    breadcrumbName: '经典案例'
  },
  '/goin': {
    title: '走进尚亚科技｜山东尚亚信息科技有限公司',
    description: '了解山东尚亚信息科技有限公司的发展历程、企业文化、团队风采、资质荣誉与合作伙伴，认识尚亚科技和刚好来品牌。',
    keywords: ['山东尚亚信息科技有限公司', '尚亚科技', '刚好来', '淄博信息科技公司'],
    heading: '走进山东尚亚信息科技有限公司',
    summary: '了解尚亚科技的企业介绍、发展历程、企业文化、团队风采、资质荣誉与合作伙伴。',
    breadcrumbName: '走进尚亚'
  },
  '/download': {
    title: '刚好来小程序与商城入口｜尚亚科技',
    description: '获取刚好来小程序与刚好来商城相关入口，随时了解尚亚科技数字化产品与服务信息。',
    keywords: ['刚好来小程序', '刚好来商城', '刚好来', '尚亚科技'],
    heading: '刚好来小程序与商城入口',
    summary: '通过刚好来小程序与商城入口，便捷获取尚亚科技数字化产品和服务信息。',
    breadcrumbName: '产品入口'
  }
};

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function escapeJsonForHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '\\u0026')
    .replace(/</g, '\\u003C')
    .replace(/>/g, '\\u003E')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}

function normalizePathname(input) {
  let raw = String(input == null ? '' : input).trim();
  if (!raw) return '/';

  if (/^https?:\/\//i.test(raw)) {
    try {
      const parsed = new URL(raw);
      raw = parsed.hash && /^#\//.test(parsed.hash) ? parsed.hash.slice(1) : parsed.pathname;
    } catch (error) {
      raw = '/';
    }
  } else {
    const hashIndex = raw.indexOf('#/');
    if (hashIndex !== -1) raw = raw.slice(hashIndex + 1);
  }

  raw = raw.split('?')[0].split('#')[0] || '/';
  if (!raw.startsWith('/')) raw = `/${raw}`;
  raw = raw.replace(/\/{2,}/g, '/');
  if (raw === '/index.html') return '/';
  if (raw.length > 1) raw = raw.replace(/\/+$/, '');
  return raw || '/';
}

function absoluteUrl(value, fallback) {
  const raw = String(value || fallback || '').trim();
  if (!raw) return SITE_URL;
  if (/^https?:\/\//i.test(raw)) return raw;
  return `${SITE_URL}${raw.startsWith('/') ? raw : `/${raw}`}`;
}

function canonicalFor(pathname) {
  return pathname === '/' ? `${SITE_URL}/` : `${SITE_URL}${pathname}`;
}

function makeBreadcrumbs(pathname, definition) {
  if (pathname === '/') return [{ name: '首页', url: `${SITE_URL}/` }];
  const crumbs = [{ name: '首页', url: `${SITE_URL}/` }];
  if (pathname === '/traffic-boost' || pathname === '/ganghaolai-mall') {
    crumbs.push({ name: '产品中心', url: `${SITE_URL}/product` });
  }
  if (/^\/casedetails\//.test(pathname)) {
    crumbs.push({ name: '经典案例', url: `${SITE_URL}/case` });
  }
  crumbs.push({ name: definition.breadcrumbName, url: canonicalFor(pathname) });
  return crumbs;
}

function mergeSeo(base, overrides) {
  const source = overrides && typeof overrides === 'object' ? overrides : {};
  const next = Object.assign({}, base);
  ['title', 'description', 'heading', 'summary', 'robots', 'ogType', 'image'].forEach(key => {
    if (typeof source[key] === 'string' && source[key].trim()) next[key] = source[key].trim();
  });
  if (Array.isArray(source.keywords)) {
    next.keywords = source.keywords.map(item => String(item).trim()).filter(Boolean);
  }
  if (source.indexable === false) {
    next.indexable = false;
    next.robots = 'noindex, nofollow';
  }
  return next;
}

function resolveSeo(input, overrides) {
  const pathname = normalizePathname(input);
  let definition = ROUTES[pathname];
  let statusCode = 200;
  let indexable = true;
  let ogType = 'website';

  if (!definition && /^\/casedetails\/[^/]+$/.test(pathname)) {
    definition = {
      title: '刚好来商城案例详情｜尚亚科技',
      description: '查看尚亚科技经典案例详情，了解刚好来商城与企业数字化项目的实际建设内容。',
      keywords: ['尚亚科技案例', '刚好来商城案例', '淄博商城刚好来'],
      heading: '尚亚科技案例详情',
      summary: '查看尚亚科技数字化项目的案例介绍与建设成果。',
      breadcrumbName: '案例详情'
    };
    ogType = 'article';
  } else if (!definition && (/^\/admin(?:\/|$)/.test(pathname) || /^\/login(?:\/|$)/.test(pathname) || /^\/api(?:\/|$)/.test(pathname))) {
    definition = {
      title: pathname.startsWith('/admin') ? '尚亚科技网站管理后台' : pathname.startsWith('/login') ? '网站内容管理中心' : '尚亚科技接口',
      description: '内部管理与服务页面。',
      keywords: [],
      heading: pathname.startsWith('/admin') ? '尚亚科技网站管理后台' : '网站内容管理中心',
      summary: '此页面不参与公开搜索索引。',
      breadcrumbName: '内部页面'
    };
    indexable = false;
  } else if (!definition) {
    definition = {
      title: '页面未找到｜尚亚科技',
      description: '您访问的页面不存在，请返回山东尚亚信息科技有限公司网站首页。',
      keywords: [],
      heading: '页面未找到',
      summary: '您访问的页面不存在，请通过网站导航访问其他内容。',
      breadcrumbName: '页面未找到'
    };
    indexable = false;
    statusCode = 404;
  }

  let seo = {
    pathname,
    title: definition.title,
    description: definition.description,
    keywords: definition.keywords.slice(),
    heading: definition.heading,
    summary: definition.summary,
    canonical: canonicalFor(pathname),
    robots: indexable ? 'index, follow' : 'noindex, nofollow',
    indexable,
    statusCode,
    ogType,
    image: DEFAULT_IMAGE,
    breadcrumbs: makeBreadcrumbs(pathname, definition)
  };

  seo = mergeSeo(seo, overrides);
  if (seo.robots.toLowerCase().includes('noindex')) seo.indexable = false;
  return seo;
}

function buildStructuredData(seoInput, organizationInput) {
  const seo = seoInput && seoInput.canonical ? seoInput : resolveSeo(seoInput || '/');
  const organization = organizationInput && typeof organizationInput === 'object' ? organizationInput : {};
  const websiteId = `${SITE_URL}/#website`;
  const organizationId = `${SITE_URL}/#organization`;
  const graph = [
    {
      '@type': 'WebSite',
      '@id': websiteId,
      name: SITE_NAME,
      alternateName: [SITE_SHORT_NAME, SITE_BRAND],
      url: `${SITE_URL}/`,
      inLanguage: 'zh-CN',
      publisher: { '@id': organizationId }
    },
    {
      '@type': 'WebPage',
      '@id': `${seo.canonical}#webpage`,
      name: seo.title,
      description: seo.description,
      url: seo.canonical,
      inLanguage: 'zh-CN',
      isPartOf: { '@id': websiteId },
      about: { '@id': organizationId }
    }
  ];

  if (seo.pathname === '/' || seo.pathname === '/goin') {
    const organizationNode = {
      '@type': 'Organization',
      '@id': organizationId,
      name: SITE_NAME,
      alternateName: [SITE_SHORT_NAME, SITE_BRAND],
      url: `${SITE_URL}/`,
      logo: {
        '@type': 'ImageObject',
        url: absoluteUrl(organization.logoUrl, '/favicon.ico')
      }
    };
    if (organization.phone) organizationNode.telephone = String(organization.phone);
    if (organization.email) organizationNode.email = String(organization.email);
    if (organization.address) {
      organizationNode.address = {
        '@type': 'PostalAddress',
        streetAddress: String(organization.address),
        addressLocality: '淄博市',
        addressRegion: '山东省',
        addressCountry: 'CN'
      };
    }
    graph.push(organizationNode);
  }

  if (seo.pathname !== '/') {
    graph.push({
      '@type': 'BreadcrumbList',
      '@id': `${seo.canonical}#breadcrumb`,
      itemListElement: seo.breadcrumbs.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.url
      }))
    });
  }

  return { '@context': 'https://schema.org', '@graph': graph };
}

module.exports = {
  SITE_URL,
  SITE_NAME,
  SITE_SHORT_NAME,
  SITE_BRAND,
  DEFAULT_IMAGE,
  PUBLIC_PATHS,
  ROUTES,
  normalizePathname,
  resolveSeo,
  buildStructuredData,
  escapeHtml,
  escapeJsonForHtml,
  absoluteUrl
};
